var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAltPropane(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "105.82mm",
    height: "122mm",
    viewBox: "0 0 105.82 122",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    x: 1.3825,
    y: 1.686,
    width: 103.03,
    height: 118.93,
    ry: 7.157,
    fillOpacity: 0,
    stroke: "#840000",
    strokeLinecap: "round",
    strokeOpacity: 0.45078,
    strokeWidth: 1.464,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m89.739 71.906-36.829-21.263-36.829 21.263",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1.704
  })), /*#__PURE__*/React.createElement("path", {
    transform: "scale(.26458)",
    d: "m61.462 271.53c-0.79827-1.4916-0.73807-2.3556 0.2152-3.0885 0.72795-0.55964 32.153-18.788 69.834-40.509l68.511-39.491 69.583 40.126c38.271 22.069 69.586 40.611 69.59 41.203 0.0285 4.8024-2.5652 3.4937-68.121-34.371-36.474-21.067-67.509-38.848-68.966-39.512-2.4216-1.1033-8.4779 2.1538-70.34 37.829-37.23 21.47-68.029 39.227-68.444 39.46-0.41452 0.23279-1.2524-0.50868-1.862-1.6477z",
    fillRule: "evenodd",
    stroke: "#ffe851",
    strokeLinejoin: "bevel",
    strokeOpacity: 0.48628,
    strokeWidth: 6.9354,
    style: {
      paintOrder: "markers stroke fill"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAltPropane);
export default __webpack_public_path__ + "static/media/altPropane.357777fa802e2ee75e9609f271cb4c4d.svg";
export { ForwardRef as ReactComponent };